import { Check } from "lucide-react";
import styles from "./home-pricing-section.module.css";

const includedFeatures = [
  "Create unlimited brainstorms",
  "Join unlimited brainstorms",
  "Up to 10 participants per brainstorm",
  "Personal AI agents",
  "Live transcription",
  "Document uploads",
  "Shared visual canvas",
  "Comments and collaboration",
];

const proBenefits = [
  "Participants join your brainstorms for free",
  "Complete brainstorm history",
  "Duplicate and reuse brainstorms",
  "Organize saved brainstorms",
  "Reusable templates",
  "Advanced exports and integrations",
];

export function ProPricingDetails() {
  return (
    <>
      <div className={styles.planHeading}>
        <p>Pro</p>
        <strong>
          $19 <small>/ month</small>
        </strong>
        <span>Keep every brainstorm and create without limits</span>
      </div>
      <div className={styles.proFeatures}>
        <FeatureColumn title="Everything included" features={includedFeatures} />
        <FeatureColumn title="More with Pro" features={proBenefits} proBenefits />
      </div>
    </>
  );
}

function FeatureColumn({
  features,
  proBenefits = false,
  title,
}: {
  features: string[];
  proBenefits?: boolean;
  title: string;
}) {
  return (
    <div
      className={`${styles.featureColumn} ${proBenefits ? styles.proBenefits : ""}`}
    >
      <p>{title}</p>
      <ul className={styles.featureList}>
        {features.map((feature) => (
          <li key={feature}>
            <Check aria-hidden="true" />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
}
